import * as React from 'react'
import { FC } from 'react'
import Shipment from '../../../../../types/api/shipment'
import { Popover } from 'antd'

interface LacquersProps {
    data: Shipment
}

const Lacquers: FC<LacquersProps> = ({ data }) => {
    return (
        <Popover
            title={
                <>
                    {data?.lacquers?.map(x => (
                        <div key={x.id}>
                            {x.type?.name} - {x.name}
                        </div>
                    ))}
                </>
            }
        >
            {data?.lacquers?.length || ''}
        </Popover>
    )
}

export default Lacquers
